"use client"

import { createContext, useContext, type ReactNode } from "react"
import { DEFAULT_REFERRAL_PROGRAM, type ReferralProgram } from "@lib/data/referral-program"

const Ctx = createContext<ReferralProgram>(DEFAULT_REFERRAL_PROGRAM)

/** Wraps the site so every client component can read the live referral terms. */
export function ReferralProgramProvider({ value, children }: { value: ReferralProgram; children: ReactNode }) {
    return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export const money = (n: number) => `$${Number.isInteger(n) ? n : n.toFixed(2)}`

/** "through October 5" while the event is on, else "". */
export function eventThrough(p: ReferralProgram): string {
    if (!p.event_active || !p.event_ends_at) return ""
    const d = new Date(p.event_ends_at)
    if (Number.isNaN(d.getTime())) return ""
    return ` through ${d.toLocaleDateString("en-US", { month: "long", day: "numeric", timeZone: "America/Chicago" })}`
}

/**
 * Live referral terms plus ready-made labels:
 *   give  "$25"   what the referred customer gets off
 *   get   "$25"   what the referrer earns
 *   min   "$100"  first-order minimum
 *   through ""    or " through October 5" during an event
 */
export function useReferralProgram() {
    const p = useContext(Ctx)
    return { ...p, give: money(p.referee_discount), get: money(p.reward_amount), min: money(p.min_order_value), through: eventThrough(p) }
}
